import { PageMeta } from "@/components/common/PageMeta";
import { useScrollPosition } from "@/hooks/useScrollPosition";
import { HeroSection } from "@/components/main-page/HeroSection";
import { BentoGridSection } from "@/components/main-page/BentoGridSection";
import { ProductsSection } from "@/components/main-page/ProductsSection";
import { TeamSection } from "@/components/main-page/TeamSection";
import { ComplianceSection } from "@/components/main-page/ComplianceSection";
import { InsightsSection } from "@/components/main-page/InsightsSection";
import { ClosingCTASection } from "@/components/main-page/ClosingCTASection";

export function MainPage() {
  const { scrollY } = useScrollPosition();

  return (
    <>
      <PageMeta
        title="AI Agents for Regulated Industries | COSX"
        description="COSX builds and deploys AI agents for regulated industries. Purpose-built for immigration law, education, and financial services with compliance, audit trails, and human oversight."
        path="/"
      />

      <main>
        <HeroSection scrollY={scrollY} />
        <BentoGridSection />
        <ProductsSection />
        <TeamSection />
        <ComplianceSection />
        <InsightsSection />
        <ClosingCTASection />
      </main>
    </>
  );
}
